import { Pipe, PipeTransform } from '@angular/core';
import { tail } from 'lodash';

@Pipe({
  name: 'tail',
  standalone: true,
})
export class TailPipe implements PipeTransform {
  transform<T>(array: T[] | undefined): T[] {
    return tail(array);
  }
}
